import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid my-10 px-5" }

import { ref, nextTick } from 'vue';
import { TableColumn } from "../../../framework/components/table/TableColumn";
import { UsersService } from "../../biz/remote/UsersService";
import { Users } from "../../../server/dto/generated/Users";
import { MessageDialog } from '../../../framework/frontend/MessageDialog';
import PagingTable from "../../../framework/components/table/PagingTable.vue";
import { AuthService } from "../../biz/remote/AuthService";
import { SessionUser, PLAN_KEY_VALUES, PLAN_KEY } from '../../utils/SessionUser';

/**
 * データロード
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'UserListPage',
  setup(__props) {

const rows = ref([] as Users[]);
const load = async () => {
  const biz = new UsersService();
  const response = await biz.usersList();
  rows.value = response.data;
};
nextTick(async ()=>await load())

const changeUserTag = async (user_id: number,authTag:PLAN_KEY)=>{
  if (await MessageDialog.confirm(`${authTag}に変更します。よろしいですか`)) {
    const biz = new AuthService()
    await biz.changeAuthTag(user_id,authTag)
    MessageDialog.info(`${authTag}`)
    SessionUser.instance.setNewAuthTagInSession(authTag)
    await load();
  }
}

const toFree = async (row: Users) => {
  await changeUserTag(row.user_id,PLAN_KEY_VALUES.free)
}

const toStandard = async (row: Users) => {
  await changeUserTag(row.user_id,PLAN_KEY_VALUES.standard)
}

const toEnterPrise = async (row: Users) => {
  await changeUserTag(row.user_id,PLAN_KEY_VALUES.enterprise)
}

const toSchool = async (row: Users) => {
  await changeUserTag(row.user_id,PLAN_KEY_VALUES.teacher)
}

const toAdmin = async (row: Users) => {
  await changeUserTag(row.user_id,PLAN_KEY_VALUES.admin)
}


/**
 * カラムの定義
 */
const cols: TableColumn[] = [
  { label: "ID", width: "70px", name: "user_id", sortitem: "user_id" },
  { label: "名前", width: "240px", name: "name", sortitem: "name" },
  { label: "メール", width: "240px", name: "mail", sortitem: "mail" },
  { label: "所属", width: "100px", name: "belong_to" },
  { label: "入会日", width: "200px", name: "join_time", type: "date" },
  { label: "認証タグ", name: "auth_tags" },
  { label: "PJ制限", name: "limit_project" },
  { label: "PJ数", name: "project_count" },
  {
    label: "Free",
    type: "button",
    btnClass: "btn btn-danger",
    onclick: toFree,
  },
  {
    label: "Standard",
    type: "button",
    btnClass: "btn btn-danger",
    onclick: toStandard,
  },
  {
    label: "School",
    type: "button",
    btnClass: "btn btn-danger",
    onclick: toSchool,
  },
  {
    label: "EnterPrise",
    type: "button",
    btnClass: "btn btn-danger",
    onclick: toEnterPrise,
  },

  {
    label: "Admin",
    type: "button",
    btnClass: "btn btn-danger",
    onclick: toAdmin,
  },


  // {
  //   label: "タグ更新",
  //   type: "button",
  //   btnClass: "btn btn-primary",
  //   onclick: async (row: Users) => {
  //     const input = MessageDialog.prompt(
  //       `${row.name}のタグを更新します。`,
  //       row.auth_tags
  //     );
  //     if (input) {
  //       const biz = new UsersService();
  //       await biz.updateTags(row.user_id, input);
  //       MessageDialog.info(`${row.name}のタグを更新しました。`);
  //       await load();
  //     }
  //   },
  // },
  { label: "ログイン数", width: "120px", name: "login_count" },
  { label: "最終ログイン", name: "last_login_dt", type: "date" },
  {
    label: "PWリセット",
    type: "button",
    btnClass: "btn btn-danger",
    onclick: async (row: Users) => {
      const user_id = row.user_id;
      if (
        confirm(
          `ユーザー[${row.name}]メール[${row.mail}]のパスワードをリセットしてよろしいですか？この操作は元に戻せません。`
        )
      ) {
        const biz = new UsersService();
        await biz.resetPassword(user_id);
        MessageDialog.info("パスワードをリセットしました。(メールアドレスの@より前)");
      }
    },
  },
  {
    label: "強制ログイン",
    type: "button",
    btnClass: "btn btn-danger",
    onclick: async (row: Users) => {
      if (confirm(`ユーザー[${row.name}]にログインします。よろしいですか？`)) {
        const biz = new AuthService();
        const response = await biz.forceLogin(row.mail);
        const session = SessionUser.saveAuthUserInSession(response.data);
        MessageDialog.info("ログインしなおしました。" + session.userName);
      }
    },
  },
];

return (_ctx: any,_cache: any) => {
  const _component_list_header = _resolveComponent("list-header")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_list_header, { class: "sticky-top px-5 pb-1 mb-4" }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(PagingTable, {
        rows: rows.value,
        "in-page-count": 30,
        columns: cols
      }, null, 8, ["rows"])
    ])
  ], 64))
}
}

})